import { loginTerms } from './index';

export const appIds = {
    xam: 'xam',
    xbm: 'xbm',
};

export const appNames = {
    XAM: 'AGENT_METRICS',
    XBM: 'BROKER_METRICS',
};

export const appLabels = {
    [appNames.XAM]: 'AgentMetrics',
    [appNames.XBM]: 'BrokerMetrics',
};

export const appIdByAppName = {
    [appNames.XAM]: appIds.xam,
    [appNames.XBM]: appIds.xbm,
};

const getIsAgentMetrics = hostname => hostname.toLowerCase().indexOf('agentmetrics') >= 0;

export const getRunningApp = hostname => getIsAgentMetrics(hostname) ? appNames.XAM : appNames.XBM;

export const runningApp = getRunningApp(window.location.host);

export const isAgentMetrics = runningApp === appNames.XAM;

export const getIsLoginPage = pathname => pathname.toLowerCase().indexOf('login') >= 0;

export const getDocumentTitle = ({ appLabel, softwareVersion, isLoginPage }) => {
    if (isLoginPage) return loginTerms.productSuite(appLabel);
    return `${appLabel} ${softwareVersion}`;
};
